/*global sprintf, tooltip */

var cbp = {
    init: function() {
        var handler = $('#cbpHandler');

        $.ajax({
            url: _d.url.offer.crossBorderView
                .replace('searchGuid', handler.data('search-guid'))
                .replace('carId', handler.data('car-id')) + '?view=' + handler.data('view'),
            type: 'GET',
            dataType: 'json',
            success: function(response) {
                handler.html(response.data);
                tooltip.init();
            },
            error: function() {
                handler.remove();
            }
        });

        cbp.action();
    },
    action: function() {
        $(document).on('click', '.cbp-toggle', function() {
            $(this).toggleClass('opened trigger-gtm-cbp');
            $('.cross-border-policy').toggle();
        });
    },
    crossBorderFee: function() {
        $(document).on('change', '.cross-border-item', function() {
            cbp.crossBorderFeeCalculation($(this));
        });
    },
    crossBorderFeeCalculation: function(that) {
        let crossBorderFeeBlock = that.parents('.cross-border-items').next('.cross-border-fee-block');
        let finalPrice = 0;
        let calculationType = that.data('calculation-type');
        const outsideCrossBorderFee = $('#crossBorderFee');
        const currencySign = crossBorderFeeBlock.data('currency-sign');
        const currencyMask = crossBorderFeeBlock.data('currency-mask');

        that.parents('.cross-border-items').find('.cross-border-item:checked').each(function() {
            let that = $(this);
            let price = parseFloat(that.data('price'));

            if (calculationType === 'sum') {
                finalPrice = finalPrice + price;
            } else {
                finalPrice = Math.max(finalPrice, price);
            }
        });

        const formattedPrice = sprintf(currencyMask, finalPrice.toFixed(2), currencySign);

        crossBorderFeeBlock.find('.cross-border-fee').html(formattedPrice);
        outsideCrossBorderFee.html(formattedPrice);

        if (that.parents('.cross-border-items').find('.cross-border-item:checked').length > 0) {
            crossBorderFeeBlock.show();
            outsideCrossBorderFee.show();
        } else {
            crossBorderFeeBlock.hide();
            outsideCrossBorderFee.hide();
        }

        cbp.crossBorderRequirements();
    },
    crossBorderRequirements: function() {
        let countryCode = [];
        let requirementsHandler = $('.cross-border-requirements');

        requirementsHandler.hide();

        $('.cross-border-item:checked').each(function() {
            countryCode.push($(this).data('country-code'));
        });

        requirementsHandler.each(function() {
            const that = $(this);
            countryCode.forEach(function(value) {
                if (that.data('countries').indexOf(value) !== -1) {
                    that.show();
                }
            });
        });
    }
};
